/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deposit_Error_Temporarily_UnavailableInputs */

const en_deposit_error_temporarily_unavailable = /** @type {(inputs: Deposit_Error_Temporarily_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deposits are temporarily unavailable. Try again shortly.`)
};

const de_deposit_error_temporarily_unavailable = /** @type {(inputs: Deposit_Error_Temporarily_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einzahlungen sind vorübergehend nicht verfügbar. Versuchen Sie es in Kürze erneut.`)
};

const pt_br2_deposit_error_temporarily_unavailable = /** @type {(inputs: Deposit_Error_Temporarily_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os depósitos estão temporariamente indisponíveis. Tente novamente em instantes.`)
};

const tr_deposit_error_temporarily_unavailable = /** @type {(inputs: Deposit_Error_Temporarily_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para yatırma işlemleri geçici olarak kullanılamıyor. Kısa süre sonra tekrar deneyin.`)
};

const zh_cn2_deposit_error_temporarily_unavailable = /** @type {(inputs: Deposit_Error_Temporarily_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`存入功能暂时不可用，请稍后重试。`)
};

const zh_hk2_deposit_error_temporarily_unavailable = /** @type {(inputs: Deposit_Error_Temporarily_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`存入服務暫時無法使用，請稍後再試。`)
};

const ko_kr2_deposit_error_temporarily_unavailable = /** @type {(inputs: Deposit_Error_Temporarily_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`입금을 일시적으로 이용할 수 없습니다. 잠시 후 다시 시도해 주세요.`)
};

const ru_ru2_deposit_error_temporarily_unavailable = /** @type {(inputs: Deposit_Error_Temporarily_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пополнения временно недоступны. Повторите попытку через некоторое время.`)
};

const es_419_deposit_error_temporarily_unavailable = /** @type {(inputs: Deposit_Error_Temporarily_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los depósitos no están disponibles temporalmente. Inténtalo de nuevo en un momento.`)
};

/**
* | output |
* | --- |
* | "Deposits are temporarily unavailable. Try again shortly." |
*
* @param {Deposit_Error_Temporarily_UnavailableInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const deposit_error_temporarily_unavailable = /** @type {((inputs?: Deposit_Error_Temporarily_UnavailableInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deposit_Error_Temporarily_UnavailableInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deposit_error_temporarily_unavailable(inputs)
	if (locale === "de") return de_deposit_error_temporarily_unavailable(inputs)
	if (locale === "pt-BR") return pt_br2_deposit_error_temporarily_unavailable(inputs)
	if (locale === "tr") return tr_deposit_error_temporarily_unavailable(inputs)
	if (locale === "zh-CN") return zh_cn2_deposit_error_temporarily_unavailable(inputs)
	if (locale === "zh-HK") return zh_hk2_deposit_error_temporarily_unavailable(inputs)
	if (locale === "ko-KR") return ko_kr2_deposit_error_temporarily_unavailable(inputs)
	if (locale === "ru-RU") return ru_ru2_deposit_error_temporarily_unavailable(inputs)
	return es_419_deposit_error_temporarily_unavailable(inputs)
});